import React, { Component } from "react";
import "./color-results.css";
import config from "../config";
import TokenService from "../services/token-service";

class ColorResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: [],
      paletteName: null,
      error: null,
    };
  }

  handleInput(event) {
    this.setState({ paletteName: event.target.value });
  }

  async savePalette() {
    this.setState({ error: null });
    const token = TokenService.getAuthToken();
    let colorIds = this.props.results.map((color) => {
      return color.color_id;
    });
    const colorsToBeSaved = {
      palette_name: this.state.paletteName,
      colors: colorIds,
    };
    if (!this.state.paletteName) {
      this.setState({ error: "Please provide a palette name" });
    } else {
      const response = await fetch(`${config.API_ENDPOINT}/saved-palettes`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(colorsToBeSaved),
      })
        .then((res) => {
          if (res.ok) {
            this.props.handleSave();
            return;
          } else {
            this.setState({ error: "Something went wrong, please try again." });
          }
        })
        .catch((res) => {
          this.setState({
            error: "Something went wrong, please try again later.",
          });
        });
      return response;
    }
  }

  render() {
    let colors;
    if (this.props.results) {
      colors = this.props.results.map((color, i) => {
        return (
          <div
            className="color-result"
            style={{ backgroundColor: `#${color.hex_code}` }}
            key={i}
          >
            <span className="color-code">{color.color_code}</span>
          </div>
        );
      });
    } else {
      colors = "";
    }

    return (
      <div>
        {colors && TokenService.hasAuthToken() ? (
          <div className="save-container">
            <label>Name</label>
            <input
              type="text"
              label="palette-name"
              onChange={(e) => {
                this.handleInput(e);
              }}
            ></input>
            <span>{this.state.error ? this.state.error : ""}</span>
            <button
              disabled={this.props.saved}
              className={`save-button ${this.props.saved ? "saved" : ""}`}
              onClick={() => this.savePalette()}
            >
              {!this.props.saved ? "Save" : "Saved!"}
            </button>
          </div>
        ) : (
          ""
        )}
        <span className="reminder">
          {colors && !TokenService.hasAuthToken()
            ? "Sign up or log in to save a palette."
            : ""}
        </span>
        <div className="color-container" id="auto-scroll">
          {colors}
        </div>
      </div>
    );
  }
}
export default ColorResults;
